import { render, staticRenderFns } from "./InquiryTest.vue?vue&type=template&id=9737edae&scoped=true"
import script from "./InquiryTest.vue?vue&type=script&lang=js"
export * from "./InquiryTest.vue?vue&type=script&lang=js"
import style0 from "./InquiryTest.vue?vue&type=style&index=0&id=9737edae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9737edae",
  null
  
)

export default component.exports